import i18n from '@/i18n'

/** 获取当前语言环境下的GuideTroubleshootingData */
const getGuideTroubleshootingData = () => {
  return [
    { title: i18n.global.t('ContentType.guide'), type: 'service_manual', list: [], articleList: [] },
    { title: i18n.global.t('ContentType.troubleshooting'), type: 'troubleshooting', list: [], articleList: [] }
  ]
}

/**
 * @description 计算服务支持分类列表
 * @param data 数据
 * @param articleType 文章类型
 */
const calculateArticleList = (data: any, articleType: string) => {
  console.log('data', data)
  console.log('articleType', articleType)
  // 动态获取当前语言环境下的数据
  const GuideTroubleshootingData: any = getGuideTroubleshootingData()
  data.support_list.forEach((item) => {
    if (item.type === 'service_manual') {
      GuideTroubleshootingData[0].articleList = classify(item)
    } else if (item.type === 'troubleshooting') {
      GuideTroubleshootingData[1].articleList = classify(item)
    }
  })
  /*
   * 兼容新旧链接的文章类型
   * 新链接可能传 section type，旧链接通常传展示文案，两种都要能定位分类
   */
  return GuideTroubleshootingData.find((item) => item.title === articleType || item.type === articleType)?.articleList || []
}

// 数据分类
const classify = (obj: { subtype_list: any[]; info_list: any[]; type: string }) => {
  // 数据分类
  let arr: any = []
  obj?.subtype_list?.forEach((item: any[]) => {
    const info_list = obj.info_list.filter((e) => e.name === item)
    arr = [...arr, { type: item, list: info_list }]
  })
  return arr
}

export { calculateArticleList }
